import { ReactComponent as PathwaysIcon } from './lib/assets/learning-icons/pathway.svg';
import { ReactComponent as AiCEIcon } from './lib/assets/learning-icons/aice.svg';
import { ReactComponent as VAIcon } from './lib/assets/learning-icons/va.svg';

import { ReactComponent as AICIcon } from './lib/assets/learning-icons/aic.svg';
import { ReactComponent as AISKIcon } from './lib/assets/learning-icons/aisk.svg';
import { ReactComponent as CCIcon } from './lib/assets/learning-icons/cc.svg';
import { ReactComponent as DAIcon } from './lib/assets/learning-icons/da.svg';
import { ReactComponent as DSIcon } from './lib/assets/learning-icons/ds.svg';
import { ReactComponent as FEIcon } from './lib/assets/learning-icons/fe.svg';
import { ReactComponent as PFIcon } from './lib/assets/learning-icons/pf.svg';
import { ReactComponent as PFEIcon } from './lib/assets/learning-icons/pfe.svg';
import { ReactComponent as BEIcon } from './lib/assets/learning-icons/be.svg';
import { ReactComponent as PBEIcon } from './lib/assets/learning-icons/pbe.svg';
import { ReactComponent as SFIcon } from './lib/assets/learning-icons/sf.svg';
import { ReactComponent as FOUNDIcon } from './lib/assets/learning-icons/founder.svg';
import { ReactComponent as FREEACIcon } from './lib/assets/learning-icons/freeac.svg';
import { ReactComponent as MAPIcon } from './lib/assets/learning-icons/map.svg';
import { ReactComponent as COCRIcon } from './lib/assets/learning-icons/cocr.svg';
import { ReactComponent as GDIcon } from './lib/assets/learning-icons/gd.svg';
import { ReactComponent as AWSCPIcon } from './lib/assets/learning-icons/aws_cp.svg';
import { ReactComponent as AWSSAIcon } from './lib/assets/learning-icons/aws_sa.svg';
import { ReactComponent as MLIcon } from './lib/assets/learning-icons/ml.svg';
import { ReactComponent as PYIcon } from './lib/assets/learning-icons/py.svg';
import { ReactComponent as ENT100Icon } from './lib/assets/learning-icons/ent100.svg';
import { ReactComponent as QNT101Icon } from './lib/assets/learning-icons/qnt101.svg';
import { ReactComponent as BUS200Icon } from './lib/assets/learning-icons/bus200.svg';
import { ReactComponent as ENT110Icon } from './lib/assets/learning-icons/ent110.svg';
import { ReactComponent as SE101Icon } from './lib/assets/learning-icons/se101.svg';
import { ReactComponent as SE102Icon } from './lib/assets/learning-icons/se102.svg';
import { ReactComponent as QNT102Icon } from './lib/assets/learning-icons/qnt102.svg';
import { ReactComponent as CSIcon } from './lib/assets/learning-icons/cybersec.svg';

export const getIconFromAbbreviation = (
  abbreviation: string,
  className: string = ''
) => {
  switch (abbreviation) {
    case 'ALX_PATHWAYS':
      return <PathwaysIcon className={className} />;
    case 'AiCE':
      return <AiCEIcon className={className} />;
    case 'AiCE2W':
      return <AiCEIcon className={className} />;
    case 'VA':
      return <VAIcon className={className} />;
    case 'PF':
      return <PFIcon className={className} />;
    case 'DA':
      return <DAIcon className={className} />;
    case 'DS':
      return <DSIcon className={className} />;
    case 'DE':
      return <DSIcon className={className} />;
    case 'CC':
      return <CCIcon className={className} />;
    case 'CS':
      return <CSIcon className={className} />;
    case 'SF':
      return <SFIcon className={className} />;
    case 'FE':
      return <FEIcon className={className} />;
    case 'PFE':
      return <PFEIcon className={className} />;
    case 'BE':
      return <BEIcon className={className} />;
    case 'PBE':
      return <PBEIcon className={className} />;
    case 'AISK':
      return <AISKIcon className={className} />;
    case 'AIC':
      return <AICIcon className={className} />;
    case 'FOUNDAC2H':
      return <FOUNDIcon className={className} />;
    case 'FOUNDAC6O':
      return <FOUNDIcon className={className} />;
    case 'FOUNDAC2O':
      return <FOUNDIcon className={className} />;
    case 'FREEAC2O':
      return <FREEACIcon className={className} />;
    case 'MAP':
      return <MAPIcon className={className} />;
    case 'COCR':
      return <COCRIcon className={className} />;
    case 'GD':
      return <GDIcon className={className} />;
    case 'AWS_CP':
      return <AWSSAIcon className={className} />;
    case 'AWS_SA':
      return <AWSCPIcon className={className} />;
    case 'ML':
      return <MLIcon className={className} />;
    case 'PY':
      return <PYIcon className={className} />;
    case 'ENT100':
      return <ENT100Icon className={className} />;
    case 'QNT101':
      return <QNT101Icon className={className} />;
    case 'BUS200':
      return <BUS200Icon className={className} />;
    case 'ENT110':
      return <ENT110Icon className={className} />;
    case 'SE101':
      return <SE101Icon className={className} />;
    case 'SE102':
      return <SE102Icon className={className} />;
    case 'QNT102':
      return <QNT102Icon className={className} />;
    default:
      return <ENT110Icon className={className} />;
  }
};

export const getDescriptionFromAbbreviation = (abbreviation: string) => {
  switch (abbreviation) {
    case 'ONB100':
      return 'Get an introduction to the ALX community and log in to essential platforms for your program.';
    case 'ENT100':
      return 'Focus on career readiness competencies and sharpen 8 key Meta Skills.';
    case 'QNT101':
      return 'Learn essential algebraic skills necessary to access higher-level tech fields.';
    case 'ALX_PATHWAYS':
      return 'Gain critical skills to ace university applications and succeed in higher education and beyond.';
    default:
      return '';
  }
};
